export default {"src":"/_next/static/media/circle.dbabb43f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};